import CartIconSvg from './../../../components/svgs/CartIconSvg';

import { ECart, EQuerykeys } from '../../../models';

import { useCartAnalytics } from '../../../hooks/useCartAnalytics';
import { useGetCart, useGetParkedCart } from '../../../integrations/react_query/queries';

type CartIconProps = {
	onClick?: () => void;
};

export function CartIcon({ onClick }: CartIconProps) {
	const { data: cartItems } = useGetCart([EQuerykeys.cart, ECart.active]);
	const { data: parkedSales } = useGetParkedCart([EQuerykeys.cart, ECart.parked]);

	const { cartLength: count } = useCartAnalytics(cartItems?.products);
	const hasParkedSales = (parkedSales ?? []).length > 0;
	const isDisabled = count === 0 && !hasParkedSales;

	return (
		<button
			onClick={onClick}
			disabled={isDisabled}
			className={`relative inline-flex items-center justify-center w-12 h-12 rounded-full bg-white shadow-lg transition-transform duration-150 ${
				isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105 active:scale-95 cursor-pointer'
			}`}
			aria-label={`Cart with ${count} items`}
		>
			<CartIconSvg />

			{count > 0 && (
				<span className="absolute top-[5px] right-1 min-w-[22px] h-[22px] flex items-center justify-center rounded-full bg-[#C53030] text-white text-xs font-bold shadow-md px-1 border-[2px] border-[#EDF2F7]">
					{count > 99 ? '99+' : count}
				</span>
			)}
		</button>
	);
}
